import {
  ApprovalDecision,
  InvestigationStatus,
  type ApprovalDecisionType,
  type InvestigationStatusType,
} from "@validereinc/domain";
import { convertMapToOpts } from "../shared/index.ts";
import { InvestigationArchiveStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";

/** Active and Archived options for investigation history status filters. */
export const InvestigationSearchStatusOptions = convertMapToOpts(
  InvestigationArchiveStatus,
  ([_, value]) => toTitleCaseString(value)
);

export const InvestigationStatusLabel: Record<InvestigationStatusType, string> =
  {
    [InvestigationStatus.PENDING]: "Pending",
    [InvestigationStatus.RUNNING]: "Running",
    [InvestigationStatus.AWAITING_EXECUTION]: "Running",
    [InvestigationStatus.DONE]: "Done",
    [InvestigationStatus.ERROR]: "Error",
  };

export const InvestigationStatusOptions = convertMapToOpts(
  InvestigationStatus,
  ([_, value]) => InvestigationStatusLabel[value]
);

/**
 * Human-readable investigation lifecycle label for tables, pills, and filters.
 */
export const getInvestigationStatusDisplayLabel = (
  status: InvestigationStatusType
): string => InvestigationStatusLabel[status];

/** Display key when a pending approval card is resolved without decision metadata. */
export const UnknownApprovalDecisionDisplayKey = "unknown" as const;
export type UnknownApprovalDecisionDisplayKeyType =
  typeof UnknownApprovalDecisionDisplayKey;

export type DisplayedApprovalDecisionType =
  | ApprovalDecisionType
  | UnknownApprovalDecisionDisplayKeyType;

export const ApprovalDecisionDisplayLabel: Record<
  DisplayedApprovalDecisionType,
  string
> = {
  [ApprovalDecision.APPROVE]: "Approved",
  [ApprovalDecision.REJECT]: "Rejected",
  [ApprovalDecision.ABANDON]: "Skipped",
  [UnknownApprovalDecisionDisplayKey]: "Unknown",
};

export const ApprovalDecisionOptions = convertMapToOpts(
  ApprovalDecision,
  ([_, value]) => ApprovalDecisionDisplayLabel[value]
);

/**
 * Human-readable operator decision for resolved pending-approval cards.
 */
export const getApprovalDecisionDisplayLabel = (
  decision: DisplayedApprovalDecisionType
): string => ApprovalDecisionDisplayLabel[decision];

export const ToolInProgressTickerLabel = "Tool in progress...";

export const PendingApprovalCardDefaultHeading = "Approval required";
export const PendingApprovalCardDefaultApproveLabel = "Approve";
export const PendingApprovalCardDefaultRejectLabel = "Reject";
export const PendingApprovalCardUnknownPayloadMessage =
  "Approval pending (unknown payload).";
export const InvestigationWriteApprovalDecisionUnavailableMessage =
  "You do not have permission to approve or reject write actions for this investigation.";
